interface DetailRowProps {
	label: string;
	value: React.ReactNode;
	last?: boolean;
}

export function DetailRow({ label, value, last }: DetailRowProps) {
	return (
		<div
			className="flex items-center justify-between px-4 py-2.5 text-sm"
			style={!last ? { borderBottom: '0.5px solid var(--line-1)' } : undefined}
		>
			<span className="text-text-3">{label}</span>
			<span className="font-medium text-text-1">{value || '—'}</span>
		</div>
	);
}
